export const SET_LOADING = '[LOADING] SET LOADING';
export const REMOVE_LOADING = '[REGISTER] REMOVE LOADING';

export function setLoading(value)
{
    return {
        type: SET_LOADING,
        payload: value
    };
}

export function removeLoading()
{
    return {
        type: REMOVE_LOADING
    }
}

